import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-xl font-bold text-foreground-50 whitespace-nowrap">奇妙漫画网</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              奇妙漫画网提供韩漫免费观看在线阅读漫画，韩国漫画免费漫画大全，一站式阅读体验。热门韩漫日漫每日更新，高清画质流畅阅读。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">分类浏览</Link></li>
              <li><Link to="/category/korean" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">韩漫专区</Link></li>
              <li><Link to="/category/japanese" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">日漫专区</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.filter(c => c.slug !== 'all').slice(0, 6).map(cat => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">联系我们</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-foreground-300">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-mail-line text-foreground-400"></i>
                </div>
                <span>contact@qimiaomanhua.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-300">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-customer-service-line text-foreground-400"></i>
                </div>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-300">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-foreground-400"></i>
                </div>
                <span>中国·北京</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 奇妙漫画网 qimiaomanhua.com - 韩漫免费观看在线阅读漫画平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}